module.exports = __webpack_public_path__ + "img/status_preparing_body.7f66a4e3.png";